import React from "react"
import Form from "./form"

interface Props {
  selectedTags: string[]
  allTags: string[]
  onChangeTags: (selectedTags: string[]) => void
}

const Header = ({ selectedTags, allTags, onChangeTags }: Props) => (
  <nav id="header" className="bg-white fixed w-full z-10 top-0 shadow">
    <div className="w-full container mx-auto flex flex-wrap items-center mt-0 pt-3">
      <div className="w-full pl-2 mb-2">
        <a
          className="text-gray-900 text-base xl:text-xl no-underline hover:no-underline font-bold"
          href="#"
        >
          <i className="fas fa-sun text-orange-600 pr-3" /> Steam Success Predictor
        </a>
      </div>

      <Form
        selectedTags={selectedTags}
        allTags={allTags}
        onChangeTags={onChangeTags}
      />
    </div>
  </nav>
)

export default Header
